<template>
<div class="chapter">
<div class="inner_page">
<p class="center4"><span><em>For Mother</em></span></p>
<hr/>
<p class="center1"><span>“To the living, one owes consideration;</span></p>
<p class="center2"><span>to the dead, only the truth.”</span></p>
<p class="indent"><span><span class="small-caps">—VOLTAIRE</span> <em>(Lettres Sur Oedipe)</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0fc69874